<div *ngIf="notification"
     class="notification-wrapper"
     [ngClass]="notification.type"
     (click)="onNotificationClick()"
     (mouseover)="onNotificationMouseover()">
  <div
    *ngIf="notification.title"
    class="notification-header"
    [innerHTML]="sanitizeHTMLStringValue(notification.title)"
  ></div>

  <div class="notification-body">
    <div class="content-item" *ngFor="let item of notification.content">
      <br *ngIf="item.wrapItem" />
      <ng-container [ngSwitch]="item.type">
        <span *ngSwitchCase="'html'" [innerHTML]="sanitizeHTMLStringValue(item.htmlString)"></span>

        <button
          *ngSwitchCase="'button'"
          class="btn"
          (click)="item.callBack(notification.id)"
          [class.text-button]="item.linkView"
          [ngClass]="item.additionalClass"
        >
          {{ item.title }}
        </button>

        <ng-container *ngSwitchCase="'link'">
          <a
            *ngIf="item.isExternalLink; else routerLinkElement"
            [ngClass]="item.additionalClass"
            [href]="sanitizeUrlStringValue(item.link)"
            [target]="item.isBlankRedirect ? '_blank' : '_self'"
          >
            {{ item.title }}
          </a>
          <ng-template #routerLinkElement>
            <a (click)="redirect(item)" [ngClass]="item.additionalClass">
              {{ item.title }}
            </a>
          </ng-template>
        </ng-container>

        <div *ngSwitchCase="'progress'" [ngClass]="item.additionalClass">
          <span class="progress-title">{{ item.title }}</span>
          <span class="progress-count">{{ item.progress$ | async }}</span>
        </div>
      </ng-container>
    </div>
     <xux-icon
      class="close-icon"
      [class.hidden]="!notification.closeNotification"
      icon="icon-close"
      (click)="closeNotification()"
    ></xux-icon>
  </div>
</div>
